import {makeStyles} from "@mui/styles";
import {lightBlue} from "@mui/material/colors";
import {DoneAll, Info, Payment, RateReview, SingleBed} from "@mui/icons-material";
import {Icon} from "@mui/material";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 20,
        height: 20,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundColor: lightBlue[500],
        scale: 1.5,
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
        backgroundColor: lightBlue[500],
    },
});

const ColorlibStepIcon = (props) => {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
        1: <SingleBed/>,
        2: <RateReview/>,
        3: <Icon>grading</Icon>,
        4: <Info/>,
        5: <Payment/>,
        6: <DoneAll/>,
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
                'icon-stepper':true
            })} style={{fontSize:'2.5rem'}}>
        </div>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};

export default ColorlibStepIcon;